const callClarity = (...args) => {
    if (typeof window.clarity === 'function') {
        window.clarity(...args);
    }
};

// Microsoft Clarity's tag, loaded unless the visitor declined the cookie banner.
// Builds without REACT_APP_CLARITY_ID (local ones) never load it.
export const loadClarity = (projectId, colla) => {
    if (!projectId || window.clarity) {
        return;
    }

    const consent = localStorage.getItem('cookie-consent');
    if (consent === 'declined') {
        return;
    }

    window.clarity = function clarity() {
        (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${projectId}`;
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript) {
        firstScript.parentNode.insertBefore(script, firstScript);
    } else {
        document.head.appendChild(script);
    }

    if (colla) {
        callClarity('set', 'colla', colla);
    }
    if (consent === 'accepted') {
        callClarity('consent');
    }
};

export const setClarityConsent = (granted) => {
    if (granted) {
        callClarity('consent');
    } else {
        callClarity('consent', false);
        callClarity('stop');
    }
};
